import { Phone, Clock, CheckCircle, AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";

export const EmergencySection = () => {
  return (
    <section className="py-20 md:py-28 bg-zinc-950 relative overflow-hidden" data-testid="emergency-section">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(
            45deg,
            transparent,
            transparent 10px,
            rgba(250,204,21,0.1) 10px,
            rgba(250,204,21,0.1) 20px
          )`
        }} />
      </div>

      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Alert badge */}
          <div className="inline-flex items-center gap-2 bg-red-600 rounded-sm px-4 py-2 mb-8">
            <AlertTriangle className="w-5 h-5 text-white" />
            <span className="text-white font-bold uppercase tracking-wide">
              Urgence Serrurier
            </span>
          </div>

          {/* Title */}
          <h2 className="text-4xl md:text-6xl font-bold uppercase tracking-tight text-white mb-8 font-heading">
            Urgence Serrurier 24h/24
            <span className="block text-yellow-400 text-2xl md:text-4xl mt-3">
              Intervention rapide
            </span>
          </h2>

          {/* Situations */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-sm p-6">
              <div className="text-3xl mb-3">🚪</div>
              <p className="text-white font-medium">Vous êtes bloqué devant votre porte ?</p>
            </div>
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-sm p-6">
              <div className="text-3xl mb-3">🔑</div>
              <p className="text-white font-medium">Clé cassée dans la serrure ?</p>
            </div>
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-sm p-6">
              <div className="text-3xl mb-3">🏠</div>
              <p className="text-white font-medium">Porte claquée avec les clés à l'intérieur ?</p>
            </div>
          </div>

          {/* Description */}
          <p className="text-lg text-zinc-300 mb-8 max-w-2xl mx-auto">
            Notre serrurier intervient <strong className="text-white">rapidement</strong> à Lieusaint 
            et dans toute la zone de Sénart.
          </p>

          {/* Response time */}
          <div className="inline-flex items-center gap-3 bg-yellow-400/10 border border-yellow-400/30 rounded-sm px-6 py-4 mb-12">
            <Clock className="w-6 h-6 text-yellow-400" />
            <div className="text-left">
              <div className="text-zinc-400 text-sm">Temps d'intervention moyen</div>
              <div className="text-yellow-400 font-bold text-2xl font-heading">15 à 30 minutes</div>
            </div>
          </div>

          {/* CTA Button - Centered with more spacing */}
          <div className="py-8 flex justify-center">
            <a href="tel:0668032561" data-testid="emergency-call-button" className="block">
              <Button className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold uppercase tracking-wide px-10 md:px-14 py-6 md:py-8 text-lg md:text-xl rounded-sm shadow-[0_0_50px_rgba(250,204,21,0.6)] animate-pulse-glow transition-all duration-300 hover:shadow-[0_0_60px_rgba(250,204,21,0.8)] hover:scale-105">
                <Phone className="w-6 h-6 mr-3" />
                APPELER LE SERRURIER – 06 68 03 25 61
              </Button>
            </a>
          </div>

          {/* Trust elements */}
          <div className="flex flex-wrap justify-center gap-6 md:gap-10 mt-8">
            <div className="flex items-center gap-2 text-zinc-300">
              <CheckCircle className="w-5 h-5 text-green-500" />
              <span>Intervention rapide</span>
            </div>
            <div className="flex items-center gap-2 text-zinc-300">
              <CheckCircle className="w-5 h-5 text-green-500" />
              <span>Devis annoncé avant intervention</span>
            </div>
            <div className="flex items-center gap-2 text-zinc-300">
              <CheckCircle className="w-5 h-5 text-green-500" />
              <span>Disponible 24h/24 et 7j/7</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmergencySection;
